module.exports = __webpack_public_path__ + "media/images/landing_page/pakalpojumu_sniedzeji_mobile-891c46321243c2714702d69cfabd4b2f.webp";